// @ vendor
const { Promise } = require('es6-promise');

function requestCards() {
    return function() {
        // (Andres): Let's keep returning an empty promise for backawards compatibility
        return Promise.resolve();
    }
}

module.exports = {
    requestCards
}
